import React from "react";
import cn from "classnames";
import { CounterBadge } from "@telia/teddy";

type Props = {
    hasNotification?: boolean;
    numberOfNotifications?: number;
    position?: "right" | "on-top-left";
    children?: React.ReactNode;
};

export const NotificationWrapper: React.FC<Props> = ({
    hasNotification,
    numberOfNotifications,
    position = "right",
    children,
}) => {
    const classNames = cn(
        "side-menu-item__badge",
        { "side-menu-item__badge--right": position === "right" },
        { "side-menu-item__badge--on-top-left": position === "on-top-left" },
    );

    if (hasNotification) {
        return (
            <>
                {children}
                <CounterBadge className={classNames} variant="warning">
                    {numberOfNotifications}
                </CounterBadge>
            </>
        );
    }
    return <>{children} </>;
};
